import { Container, Segment, SegmentHeader } from '@/platform/ui';
import Navigation from '@/platform/views/Questionnaires/components/Navigation';
import QuestionnaireForm from '@/platform/views/Questionnaires/components/QuestionnaireForm';

const CreateOrUpdateView = () => (
    <Container>
        <Navigation />

        <Segment>
            <SegmentHeader
                header='No-riskpolis vragenlijst instellingen'
                subheader='Gebruik deze sectie om no-riskpolis vragen te definiëren die in vragenlijsten zullen verschijnen.'
            />
        </Segment>

        <QuestionnaireForm submitUrl='/services/no-risk/questionnaires' />
    </Container>
);

export default CreateOrUpdateView;
